<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="">
            <div class="form-card-wrapper">
              <b-card header="Contenuto" header-tag="header">
                <template #header>
                  <b>Contenuto</b>
                </template>
                <b-card-text>
                  <b-row>
                    <div class="form-group">
                      <base-input
                        name="title"
                        vid="title"
                        label="Titolo"
                        v-model="form[rep].title"
                        placeholder="Inserisci un titolo"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-select
                        name="type"
                        label="Tipo"
                        v-model="form[rep].type"
                        :options="types"
                        :taggable="false"
                        :multiple="false"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-input
                        name="margin_left"
                        vid="margin_left"
                        label="Margine sinistro (mm)"
                        v-model="form[rep].margin_left"
                        placeholder="Inserisci margine sinistro"
                        type="number"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-input
                        name="margin_right"
                        vid="margin_right"
                        label="Margine destro (mm)"
                        v-model="form[rep].margin_right"
                        placeholder="Inserisci Margine destro"
                        type="number"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-input
                        name="margin_top"
                        vid="margin_top"
                        label="Margine alto (mm)"
                        v-model="form[rep].margin_top"
                        placeholder="Inserisci margine alto"
                        type="number"
                        :rules="{ required: true }"
                      />
                    </div>
                    <div class="form-group">
                      <base-input
                        name="margin_down"
                        vid="margin_down"
                        label="Margine basso (mm)"
                        v-model="form[rep].margin_bottom"
                        placeholder="Inserisci margine basso"
                        type="number"
                        :rules="{ required: true }"
                      />
                    </div>
                  </b-row>
                  <div v-for="(config, index) in editor_config" :key="index">
                    <div class="mt-2 form-group">
                      <label>{{ config.title }}</label>
                      <base-editor-pdf
                        :editor_id="config.editor_id"
                        :height="config.height"
                        :image_list="images"
                        v-model="form[rep][config.model]"
                        :isEdit="true"
                        @onInitEditEditor="onInitEditEditor"
                        @updateEditorContent="
                        updateEditorContent(config.model, $event)
                      "
                      />
                    </div>
                  </div>
                  <div>
                    <div class="form-group">
                      <base-textarea
                        vid="css"
                        name="css"
                        label="Css"
                        v-model="form[rep].css"
                        placeholder="Inserisci css"
                      />
                    </div>
                  </div>
                </b-card-text>
              </b-card>
            </div>
            <div class="form-actions form-actions--sticky">
              <div class="inner-wrapper">
                <div>
                  <span
                    :title="`${
                      invalid
                        ? 'Compila correttamente i campi per poter salvare'
                        : 'Invia il form'
                    }`"
                  >
                    <b-button
                      @click="handleSubmit(onSubmit)"
                      type="button"
                      :disabled="invalid"
                      variant="lisaweb"
                      size="sm"
                    >
                      Salva
                    </b-button></span
                  >
                  <b-button
                    type="button"
                    variant="lisaweb"
                    size="sm"
                    @click="showPdfPreview"
                  >
                    Preview
                  </b-button>
                  <b-button
                    type="button"
                    variant="lisaweb"
                    size="sm"
                    @click="onDuplicate"
                    title="Duplica template"
                  >
                    <b-icon icon="files"></b-icon> Duplica
                  </b-button>
                </div>
                <div>
                  <b-button
                    @click="$router.back()"
                    size="sm"
                    class="btn--transparent"
                    title="Torna alla pagina precedente"
                  >
                    <b-icon-chevron-double-left
                      font-scale="0.9"
                    ></b-icon-chevron-double-left>
                    Torna indietro
                  </b-button>
                </div>
              </div>
            </div>
          </b-form>
        </validation-observer>
        <duplicate-lisacomunica-template-modal
          :id="duplicateModalId"
          :repository="repository"
          :item="duplicateItem"
          :type-label="typeLabel"
          @duplicated="onDuplicated"
        />
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
// import BaseIcon from "@/components/BaseIcon";
import BaseSelect from "@/components/form/BaseSelect";
import BaseInput from "@/components/form/BaseInput";
import BaseTextarea from "@/components/form/BaseTextarea.vue";
import BaseEditorPdf from "@/components/form/BaseEditorPdf";
import DuplicateLisacomunicaTemplateModal from "@/components/modals/duplicateLisacomunicaTemplateModal";

export default {
  mixins: [ShortcutMixin, LisaComunicaMixin],
  data() {
    return {
      repository: "pdf",
      typeLabel: "Pdf",
      duplicateModalId: "duplicatePdfEditModal",
      duplicateItem: {},
      isLoading: true,
      id: this.$route.params.id,
      types: [
        {value: "AVV_SCAD", text: "Avvisi scadenza"},
        {value: "MKTG", text: "Marketing"},
        {value: "SOLL", text: "Solleciti"},
        {value: "REN_PRO", text: "Rendiconti"},
      ],
      images: [],
      editor_config: [
        {
          title: "Header",
          height: 200,
          model: "header",
          editor_id: "pdf_header",
        },
        { title: "Body", height: 600, model: "body", editor_id: "pdf_body" },
        { title: "Ads", height: 200, model: "ads", editor_id: "pdf_ads" },
        {
          title: "Footer",
          height: 200,
          model: "footer",
          editor_id: "pdf_footer",
        },
      ],
      form: {
        pdf: {
          title: null,
          type: null,
          margin_left: null,
          margin_right: null,
          margin_top: null,
          margin_bottom: null,
          css: null,
          header: "",
          body: "",
          ads: "",
          footer: "",
        },
      },
      original_value_header: null,
      original_value_body: null,
      original_value_ads: null,
      original_value_footer: null,
      updated_content_header: null,
      updated_content_body: null,
      updated_content_ads: null,
      updated_content_footer: null,
      table_row_item: this.$route.params.item ? this.$route.params.item : {},
    };
  },
  components: {
    // BaseIcon,
    BaseInput,
    BaseSelect,
    BaseTextarea,
    BaseEditorPdf,
    DuplicateLisacomunicaTemplateModal,
  },
  methods: {
    updateEditorContent(model, contentHtml) {
      console.log("contentHtml", contentHtml);
      console.log("config.model", model);
      switch (model) {
        case "header":
          this.updated_content_header = contentHtml;
          break;
        case "body":
          this.updated_content_body = contentHtml;
          break;
        case "ads":
          this.updated_content_ads = contentHtml;
          break;
        case "footer":
          this.updated_content_footer = contentHtml;
          break;
      }
    },
    onInitEditEditor() {
      console.log("onInitEditEditor");
      setTimeout(() => {
        this.form[this.rep].header = this.original_value_header;
        this.form[this.rep].body = this.original_value_body;
        this.form[this.rep].ads = this.original_value_ads;
        this.form[this.rep].footer = this.original_value_footer;
      }, 300);
    },
    onDuplicate() {
      this.duplicateItem = { id: this.id, title: this.form[this.rep].title };
      this.$bvModal.show(this.duplicateModalId);
    },
    onDuplicated() {
      // /new non restituisce l'id del nuovo template: torniamo all'elenco
      this.shortcut("lisacomunica_template", null, "#Pdf", "filterPdf");
    },
    onSubmit() {
      this.form[this.rep].header = this.get_html_from_iframe("pdf_header");
      this.form[this.rep].body = this.get_html_from_iframe("pdf_body");
      this.form[this.rep].ads = this.get_html_from_iframe("pdf_ads");
      this.form[this.rep].footer = this.get_html_from_iframe("pdf_footer");

      if (
        !this.form[this.rep].header ||
        this.form[this.rep].header === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].header === `<p></p>`
      ) {
        this.form[this.rep].header = this.original_value_header;
      }
      if (
        !this.form[this.rep].body ||
        this.form[this.rep].body === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].body === `<p></p>`
      ) {
        this.form[this.rep].body = this.original_value_body;
      }
      if (
        !this.form[this.rep].ads ||
        this.form[this.rep].ads === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].ads === `<p></p>`
      ) {
        this.form[this.rep].ads = this.original_value_ads;
      }
      if (
        !this.form[this.rep].footer ||
        this.form[this.rep].footer === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].footer === `<p></p>`
      ) {
        this.form[this.rep].footer = this.original_value_footer;
      }
      if (
        !this.form[this.rep].body ||
        this.form[this.rep].body === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].body === `<p></p>` ||
        !this.form[this.rep].header ||
        this.form[this.rep].header === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].header === `<p></p>` ||
        !this.form[this.rep].footer ||
        this.form[this.rep].footer === `<p><br data-mce-bogus="1"></p>` ||
        this.form[this.rep].footer === `<p></p>`
      ) {
        this.$showSnackbar({
          preset: "error",
          text: `C'è stato un problema durante il salvataggio. Ti preghiamo di riprovare più tardi.`,
        });
        return;
      }
      this.isSavingTemplate = true;
      this.update()
        .then(() => {
          this.isSavingTemplate = false;
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Template Pdf Modificato`,
          });
          this.shortcut("lisacomunica_template", null, "#Pdf", "filterPdf");
        })
        .catch((error) => {
          let errMsg =
            error?.response?.data?.message || this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isSavingTemplate = false;
        });
    },
  },
  created() {
    this.show()
      .then((response) => {
        this.initializeEditForm(response.data.content);
        this.original_value_header =
          this.form[this.rep].header ?? this.table_row_item?.header;
        this.original_value_body =
          this.form[this.rep].body ?? this.table_row_item?.body;
        this.original_value_ads =
          this.form[this.rep].ads ?? this.table_row_item?.ads;
        this.original_value_footer =
          this.form[this.rep].footer ?? this.table_row_item?.footer;
        this.form[this.rep].header = "";
        this.form[this.rep].body = "";
        this.form[this.rep].ads = "";
        this.form[this.rep].footer = "";
        this.index("", "image")
          .then((response) => {
            this.setImages(response.data.content);
            this.isLoading = false;
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({
              preset: "error",
              text: `${errMsg}`,
            });
            this.isLoading = false;
          });
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
        this.isLoading = false;
        this.ok = true;
      });
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
};
</script>
